import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {TreeTable} from 'primereact/treetable';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const CostcenterListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [costcenters, setCostcenters] = useState([]);
  const [costCenterTree, setCostCenterTree] = useState([]);
  const [treeView, setTreeView] = useState(true);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/cost-center' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setCostcenters(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const loadTreeData = () => {
    setLoading(true);
    apiCall('get', '/api/v2/cost-center/tree')
      .then(response => setCostCenterTree(response.data?.data?.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response))
      .finally(() => setLoading(false));
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button  icon="pi pi-eye"
                  className="p-button p-mr-2"
                  tooltip={t('view')}
                  tooltipOptions={{ position: 'left' }}
                  onClick={() => {
                    if (entity === 'cost-center') {
                      history.push('/finance/' + props.entity + '/read/' + rowData.id + history.location.search);
                    }
                  }}/>
        {localStorage.getItem('roles').toString().includes('role_cost_center_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'cost-center') {
                      history.push('/finance/cost-center/update/' + rowData.id)
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_cost_center_write') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/cost-center/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderCostcenterList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    if (treeView) {
      loadTreeData();
    } else {
      loadLazyData();
    }
  }, [lazyParams, treeView, window.App.state.rerenderCostcenterList])

  return (
    <>
      <div className="p-d-flex p-jc-end p-mb-2">
        <Button type="button" icon="pi pi-sitemap" label={t('treeView')}
                className={treeView ? 'p-button' : 'p-button-outlined'} onClick={() => setTreeView(true)}/>
        <Button type="button" icon="pi pi-list" label={t('listView')}
                className={!treeView ? 'p-button p-ml-2' : 'p-button-outlined p-ml-2'} onClick={() => setTreeView(false)}/>
      </div>
      {treeView ?
        <TreeTable value={costCenterTree} loading={loading} emptyMessage={t('noResults')}>
          <Column field="name" header={t('columnName')} expander body={(node) => node.data?.name}/>
          <Column field="code" header={t('columnIdentifier')} body={(node) => node.data?.code}/>
          <Column header={t('columnBusinessUnit')} body={(node) => node.data?.profit_center?.name ?? '-'}/>
          <Column body={(node) => actionBodyTemplate(node.data)} className="p-py-0 p-text-right p-text-nowrap"/>
        </TreeTable>
        : <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={costcenters} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter></Column>
        <Column field="code" header={t('columnIdentifier')} sortable filter></Column>
        <Column header={t('columnBusinessUnit')} body={(rowData) => rowData.profit_center?.name ?? '-'} />
        {/* <Column field="active" header={t('columnActive')} sortable filter></Column> */}




        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>}
    </>
  )
}
export default withTranslation('common')(CostcenterListComponent);
